import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';import RecentlyViewed from './RecentlyViewed';
import { Helmet } from 'react-helmet';



function HomePage() {
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [radius, setRadius] = useState('25');
  const [zip, setZip] = useState('');
  const [error, setError] = useState('');
  const [cars, setCars] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
const [showNotifyForm, setShowNotifyForm] = useState(false);
const [notifyEmail, setNotifyEmail] = useState('');
const [notifySubmitted, setNotifySubmitted] = useState(false);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE}/cars/makes`)
      .then(res => res.json())
      .then(data => setMakeOptions(data));
  }, []);

  useEffect(() => {
    if (make) {
      fetch(`${process.env.REACT_APP_API_BASE}/cars/models?make=${encodeURIComponent(make)}`)
        .then(res => res.json())
        .then(data => setModelOptions(data));
    } else {
      setModelOptions([]);
    }
  }, [make]);

  useEffect(() => {
    // fetch(`${process.env.REACT_APP_API_BASE}/cars/sold-carousel`)
    //   .then(res => res.json())
    //   .then(data => setCars(Array.isArray(data) ? data : []))
    //   .catch(() => setCars([]));

    if (!zip && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
          const data = await response.json();
          const postal = data.address?.postcode;
          if (postal && /^[0-9]{5}$/.test(postal)) {
            setZip(postal);
          }
        } catch (err) {
          console.log("ZIP auto-detection failed:", err);
        }
      });
    }

     
  }, []);

        sessionStorage.setItem('cachedCars',  []);
        sessionStorage.setItem('cachedTotalPages',  '0');
        sessionStorage.setItem('cachedTotalResults', '0');
        sessionStorage.setItem('cachedPage', "");
        sessionStorage.setItem('cachedScroll', '0');
  
  useEffect(() => {
    if (cars.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % cars.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [cars]);

  const handleSearch = () => {
    if (!zip) {
      setError('ZIP code is required.');
      return;
    }
    if (!/^[0-9]{5}$/.test(zip)) {
      setError('ZIP must be 5 digits.');
      return;
    }
 // ✅ Require both make and model
  if (!make || !model) {
    setError('Please select both a make and a model before searching.');
    return;
  }
// const zipPrefix = zip.substring(0, 3);
// const allowedPrefixes = ['327', '328', '330', '331', '333', '334', '347', '349'];
// if (!allowedPrefixes.includes(zipPrefix)) {
//     setShowNotifyForm(true);
//   setError('We currently support South & Central Florida — from Key West to Orlando. More regions coming soon!');
//   return;
// }

    setError('');
    const query = new URLSearchParams();
    if (make) query.append('make', make);
    if (model) query.append('model', model);
    if (radius) query.append('radius', radius);
    query.append('zip', zip);
    navigate(`/search?${query.toString()}`);
  };

  return (
    <>
    <Helmet><link rel="icon" type="image/png" href="https://meshumimages.blob.core.windows.net/websiteimages/favicon.png" />
  <title>Meshum – Compare Car Listings to Real Sale Prices</title>
  <meta
    name="description"
    content="Search cars for sale and compare to recently sold prices nearby. Meshum helps you find fair deals with confidence."
  />
  <meta property="og:title" content="Meshum – Car Pricing Insights" />
  <meta
    property="og:description"
    content="See real car sales data alongside active listings to make smarter buying decisions."
  />
</Helmet>

    <main>
<section className="text-center py-10 bg-gray-50 border-b">
  <h1 className="text-3xl sm:text-4xl font-bold text-blue-700 mb-2">Compare Listings with Real Sale Prices</h1>
  <p className="text-gray-600 text-sm sm:text-base max-w-xl mx-auto">
    Meshum helps car buyers make smarter decisions by showing actual sold prices next to active listings.
  </p>
</section>

     <div className="flex flex-col sm:flex-row flex-wrap sm:items-center gap-4 p-4 bg-white rounded-lg shadow mb-6 max-w-screen-lg mx-auto">
  {/* Make */}
  <div className="w-full sm:w-auto flex-1 min-w-[140px]">
    <select
      value={make}
      onChange={(e) => setMake(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
    >
      <option value="">All Makes</option>
      {makeOptions.map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
    </select>
  </div>

  {/* Model */}
  <div className="w-full sm:w-auto flex-1 min-w-[140px]">
    <select
      value={model}
      onChange={(e) => setModel(e.target.value)}
      disabled={!make}
      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm disabled:bg-gray-100"
    >
      <option value="">All Models</option>
      {modelOptions.map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
    </select>
  </div>

  {/* ZIP Code */}
  <div className="w-full sm:w-auto flex-1 min-w-[100px] max-w-[120px]">
    <input
      type="text"
      placeholder="ZIP Code"
      value={zip}
      onChange={(e) => setZip(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
    />
  </div>

  {/* Search Button */}
  <div className="w-full sm:w-auto">
    <button
      onClick={handleSearch}
      className="w-full sm:w-auto bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700 transition"
    >
      Search
    </button>
  </div>
</div>
{error && (
  <div className="text-red-600 text-sm text-center mt-2">
    {error}
  </div>
)}

{/* {showNotifyForm && !notifySubmitted && (
  <div className="text-center mt-4">
    <p className="text-gray-700 text-sm mb-2">
      We’re not in your area yet — but we’re expanding! Get notified when we are.
    </p>
    <input
      type="email"
      placeholder="Your email"
      value={notifyEmail}
      onChange={(e) => setNotifyEmail(e.target.value)}
      className="border px-3 py-2 rounded w-full max-w-xs text-sm"
    />
    <button
      onClick={async () => {
        await fetch(`${process.env.REACT_APP_API_BASE}/public/notify-when-live`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zip, email: notifyEmail }),
        });
        setNotifySubmitted(true);
      }}
      className="mt-2 bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700 transition"
    >
      Notify Me
    </button>
  </div>
)} */}
{/* 
{notifySubmitted && (
  <div className="text-center text-green-600 text-sm mt-4">
    Thank you! We’ll email you as soon as we’re live in your area.
  </div>
)} */}


       
<div className="text-center text-sm text-gray-500 mt-8">
  Trusted by smart buyers across the U.S. | No ads, no BS – just real price insights.
</div>
      {/* 🔁 Carousel One-at-a-Time */}
     
      {/* <div style={{
        width: '100%',
        maxWidth: '360px',
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative'
      }}>
        {cars.length > 0 && (
          <div
            key={cars[currentIndex].id}
            onClick={() => navigate(`/car/${cars[currentIndex].id}`)}
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '1rem',
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'opacity 0.5s ease-in-out'
            }}
          >
            <img
              src={cars[currentIndex].imageUrl || "https://meshumimages.blob.core.windows.net/websiteimages/defaultCar.jpg"}
              alt="Car"
              style={{ width: '100%', borderRadius: '6px', marginBottom: '0.5rem' }}
            />
            <h4 style={{ margin: "0 0 0.25rem 0" }}>{cars[currentIndex].make} {cars[currentIndex].model}</h4>
            <p style={{ margin: 0, color: "#666" }}>Year: {cars[currentIndex].year}</p>
            <p style={{ margin: "0.25rem 0", fontWeight: "bold", color: "#004D40" }}>
              ${cars[currentIndex].price.toLocaleString()}
            </p>
          </div>
        )}
      </div> */}


      {/* 🕘 Recently Viewed Cars */}
    <RecentlyViewed cars={JSON.parse(localStorage.getItem('recentlyViewedCars') || '[]')} />


    </main>
    </>
  );
}

export default HomePage;
